<template>
  <div class="hello">
    <!-- <span>{{ht}}</span> -->
    <!--页首-->
    <Header :ifblueho="ifblueho"></Header>
    <!--正文-->
    <div class="content-body">
      <!--新闻-->
      <div class="main-item2">
        <div class="news-left">
          <div class="news-bottom" style="background-color: #000000"></div>
          <div class="news-bottom" style="z-index: 999;opacity: 1.0;">
            <!--标题-->
            <h5 class="news-bottomH5" style="opacity: 1;color: #ffffff;margin-top: 3px" v-for="(b, index) in banner"
              v-show="index === mark" :key="index">
              {{ b.title }}
            </h5>
            <!--小圆点-->
            <div style="float: right">
              <span v-on:mouseover="bannerSpan($event)" v-for="(img, index,) in banner" :key="index" :id="'bannerSp' + index"
                :class="{ sp_advertisement: !(index === mark), sp_advertisement_on: index === mark }"></span>
            </div>
          </div>
          <!--图片和链接-->
          <a :href="b.url" v-for="(b, index) in banner" v-show="index === mark" :key="index" @mouseover="stoptimer"
            @mouseout="play">
            <img id="newsimg" :src="b.img" style="width: 100%;object-fit: cover;" />
          </a>
        </div>
        <div class="news-right">
          <div class="item-top">
            <span><img class="item-titleSpan" src="../assets/img/titleSpan.png"></span>
            <span class="item-topTitle">新闻动态</span>
            <!--<span class="item-topSubTitle">news</span>-->
            <span class="item-topMore">
              <router-link class="item-topMoreA" to="/news">MORE+</router-link>
            </span>
          </div>
          <!--<new-right-item v-for="(n,index) in notices" :key="index" :articleId="n.id" :title="n.title" :rightnewTitle="n.title" :rightnewTest="n.content" :rightnewTime="n.create_time" :rightnewAuthor="n.from"></new-right-item>-->
          <new-right-item v-for="(n, index) in news" :key="index" :articleId="n.id" :title="n.title"
            :rightnewTitle="n.title" :rightnewTest="n.content" :rightnewTime="n.create_time"
            :rightnewAuthor="n.from"></new-right-item>
        </div>
      </div>
      <!--广告-->
      <div class="main-item2">
        <div class="item-body" style="position:relative;top:30px;overflow: hidden;">
          <!-- <img :src="middle_avatar" style="width: 100%;margin-top: 20px;"> -->
          <el-carousel :interval="5000" arrow="always" height="115px" indicator-position="none" style="width: 100%"
            ref="middlecart">
            <el-carousel-item v-for="(item, index) in middle_avatar" :key="index" style="width: 100%;">
              <a v-if="index === 0" href="http://www.tme-exhibition.com/2026/#/home" target="_blank"><img @click="diu(index)"
                  :src="item" alt="" style="display:block;width:100%"></a>
              <a v-if="index === 1" href="http://www.tme-exhibition.com/new/2026/#/home" target="_blank"><img @click="diu(index)"
                  :src="item" alt="" style="display:block;width:100%"></a>
              <a v-if="index === 2" href="http://auto.861718.com/2022/#/home" target="_blank"><img @click="diu(index)"
                  :src="item" alt="" style="display:block;width:100%"></a>

            </el-carousel-item>
          </el-carousel>
          <div style="float: right">
            <span v-on:mouseover="MiddlebannerSpan($event, index)" v-for="(item, index) in middle_avatar" :key="index"
              :class="{ sp_advertisement: !(index === middleIndex), sp_advertisement_on: index === middleIndex }"
              style="position: relative;top: -24px;left: 5px;margin-left:-6px;box-shadow: 1px 2px 1px rgba(0,0,0,0.4), -2px 2px 3px rgba(0,0,0,0.1);"></span>
          </div>
        </div>
      </div>
      <!--通知-->
      <div class="main-item2">
        <div class="item-top">
          <span><img class="item-titleSpan" src="../assets/img/titleSpan.png"></span>
          <span class="item-topTitle">通知服务</span>
          <!--隐藏了切换栏（可能要用到）-->
          <router-link class="item_topSpan" tag="span" to="/paper">学会论文</router-link>
          <router-link class="item_topSpan" tag="span" to="/service">学会服务</router-link>
          <span v-for="(n, index) in notices" :key="index" @mouseover="noticeSpan($event)" :id="'noticeSpan' + index"
            :class="{ item_topSpan: !(notice === index), item_topSpan_on: notice === index }">{{ n.title }}</span>
        </div>
        <!--旧的通知盒子样式（可能要用到）-->
        <div v-for="(n, index) in notices" class="item-body" :key="index" v-show="notice === index"
          style="overflow: hidden;min-height: 200px">
          <announcementNew v-for="(ann, index) in n.list" :articleId="ann.id" :tabName="message" :title="ann.title"
            :key="index" :cover="ann.cover" :annDay="ann.create_time.substring(ann.create_time.length - 2)"
            :annData="ann.create_time.substr(0, 7)" :annTitle="ann.title" :annTest="ann.content"></announcementNew>
        </div>
        <!--新的通知盒子样式-->
        <!--<div v-for="(n, index) in news" class="item-body" :key="index" v-show="notice===index" style="overflow: hidden;min-height: 200px">-->
        <!--<announcementNew v-for="(ann,index) in n.list" :articleId="ann.id" :tabName="message" :title="ann.title" :cover="ann.cover" :key="index" :annDay="ann.create_time.substring(ann.create_time.length-2)" :annData="ann.create_time.substr(0,7)" :annTitle="ann.title" :annTest="ann.content"></announcementNew>-->
        <!--</div>-->
      </div>
      <!--会员单位-->
      <div class="main-item2">
        <div class="item-top">
          <span><img class="item-titleSpan" src="../assets/img/titleSpan.png"></span>
          <span class="item-topTitle">会员单位</span>
          <!--<span class="item-topSubTitle">Member unit</span>-->
          <span class="item-topMore"><router-link class="item-topMoreA" to="/member">MORE+</router-link></span>
        </div>
        <div class="item-body"
          style="display: flex;flex-wrap: wrap;justify-content: space-between;height: 320px;overflow-y: scroll;">
          <div v-for="(m, index) in member" v-bind:key="index"
            style="box-shadow:1px 1px 5px #666666;width:168px;height:94px;background:#fff;margin: 10px;text-align: center;line-height: 90px;">
            <img :src="m" style="max-height: 100%;max-width:100%;vertical-align: middle; ">
          </div>
        </div>
      </div>
      <!--友情链接-->
      <!--<div class="main-item2">
        <div class="item-body">
          <a v-for="(l, index) in link" :href="l[1]" :key="index" style="color: #000000;margin-left: 7px;font-size: 12px">{{l[0]}}</a>
        </div>
      </div>-->
    </div>
    <!--页脚-->
    <Footer></Footer>
  </div>
</template>
<script>
import newRightItem from '@/components/news/new-rightItem.vue'
import announcement from '@/components/news/announcement.vue'
import announcementNew from '@/components/news/announcementNew.vue'
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import HttpServer from '@/utils' // 接口请求
import { getMiddle } from '../api.js'
import '../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'HelloWorld',
  data () {
    return {
      // **显示哪张图片
      mark: 0,
      // **显示哪个通知栏
      notice: 0,
      // 顶部导航栏
      ifblueho: { color: '#0051bd' },
      // 左侧轮播图
      banner: [],
      // 中间轮播图
      middleIndex: 0,
      // 右侧新闻盒子
      news: [],
      // 通知盒子
      notices: [],
      // 会员单位
      member: [],
      // 友情链接
      link: [],
      // 底部广告图
      middle_avatar: [],
      // 底部网站信息
      foot: '',
      // 文章传参
      message: 'news',
      // 定时器
      timer: null,
      ht: ''
    }
  },
  components: {
    // 组件
    newRightItem: newRightItem,
    announcement: announcement,
    announcementNew: announcementNew,
    Footer: Footer,
    Header: Header
  },
  methods: {
    // diu (index) {
    //   console.log(index)
    //   if (index === 0) {
    //     // window.open('http://5g.861718.com/', '_blank')
    //     window.open('http://19auto-testing.861718.com/home', '_blank')
    //   } else {
    //     window.open('http://19auto-testing.861718.com/home', '_blank')
    //   }
    // },
    // 轮播图
    autoPlay () {
      this.mark++
      if (this.mark === this.banner.length) {
        this.mark = 0
      }
    },
    play () {
      this.timer = setInterval(this.autoPlay, 2500)
    },
    // 轮播图的span悬停事件
    bannerSpan (event, index) {
      this.mark = +event.target.id.replace('bannerSp', '')
    },
    MiddlebannerSpan (event, index) {
      this.middleIndex = index
      this.$refs.middlecart.setActiveItem(index)
    },
    // 通知的span悬停事件
    noticeSpan (event, index) {
      this.notice = +event.target.id.replace('noticeSpan', '')
    },
    stoptimer () {
      clearInterval(this.timer)
    },
    api_server1 () {
      // 调用主页接口this.GLOBAL.userSite =http://ysw.861718.com/
      HttpServer.get(this.GLOBAL.userSite + 'gdics.php/index').then(res => {
        console.log(res)
        this.link = res.link
        this.member = res.member
        this.news = res.news
        this.banner = res.banner
        this.notices = res.notice
        console.log(this.notices)
      })
    },
    async getData () {
      let { data } = await getMiddle()
      this.middle_avatar = [...data]
      console.log(this.middle_avatar)
    }
  },
  created () {
    // 轮播图
    this.play()
  },
  mounted () {
    this.api_server1()
    this.getData()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import '../../node_modules/bootstrap/dist/css/bootstrap.css';
@import 'joinprocess/main.css';

.news-left {
  position: absolute;
  height: 381px;
  overflow: hidden;
  width: calc(40%);
  max-width: 560px;
  margin-left: 5px;
}

.news-left img {
  height: 100%;
}

/**/
.news-right {
  width: calc(48%);
  padding: 10px;
  box-sizing: border-box;
  height: 381px;
  float: right;
  background-color: #ffffff;
  margin-right: 15px;
  overflow-y: scroll;
}

.news-bottom {
  position: absolute;
  width: 100%;
  height: 45px;
  bottom: 0px;
  padding-top: 14px;
  padding-left: 20px;
  text-align: left;
  opacity: 0.5;
  z-index: 998;
}

.news-bottomH5 {
  float: left;
  color: #ffffff;
  font-size: 14px;
  opacity: 1;
  z-index: 999;
}

.sp_advertisement {
  border-radius: 50%;
  background-color: #555555;
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #999999;
  margin-top: 3px;
  margin-right: 12px;
  cursor: pointer;
  opacity: 1;
  z-index: 999;
}

.sp_advertisement_on {
  border-radius: 50%;
  background-color: #ffffff;
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #999999;
  margin-top: 3px;
  margin-right: 12px;
  cursor: pointer;
  opacity: 1;
  z-index: 999;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #dbd9d9;
  border-radius: 3px;
}</style>



// WEBPACK FOOTER //
// src/components/home.vue